<template>
  <div class="aboutus-container">
    <div class="aboutus-top-container">
      <app-navbar rootClassName="navbar-root-class-name"></app-navbar>
      <div class="aboutus-hero">
        <div class="aboutus-container1">
          <h1 class="aboutus-text heading">About us</h1>
        </div>
        <div class="aboutus-content-container">
          <div class="aboutus-container2"></div>
        </div>
      </div>
    </div>
    <div id="main-section" class="aboutus-main">
      <div class="aboutus-features">
        <h1 class="aboutus-text01"><span>What we stand for</span></h1>
        <span class="aboutus-text03">
          <span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In lorem
            lorem, malesuada in metus vitae, scelerisque accumsan ipsum. Nam
            pellentesque nulla leo, sagittis vehicula sem commodo nec.​
          </span>
          <span></span>
        </span>
      </div>
    </div>
    <div class="aboutus-footer">
      <div class="aboutus-menu">
        <h1>
          <span>Madeira</span>
          <br />
          <span>Roots</span>
        </h1>
        <div class="aboutus-links-container">
          <div class="aboutus-container3">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link"
            >
              Tour packages
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link01"
            >
              Personalized to
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link02"
            >
              Special deals
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link03"
            >
              Summer holiday
              <span v-html="raw3np3"></span>
            </a>
          </div>
          <div class="aboutus-container4">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link04"
            >
              About us
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link05"
            >
              FAQ
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link06"
            >
              Terms and conditions
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link07"
            >
              Contact
            </a>
          </div>
        </div>
        <div class="aboutus-follow-container">
          <span class="aboutus-text09">
            Follow us on
            <span v-html="rawyljb"></span>
          </span>
          <div class="aboutus-icons-container">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link08"
            >
              <svg viewBox="0 0 877.7142857142857 1024" class="aboutus-icon">
                <path
                  d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                ></path>
              </svg>
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer noopener"
              class="aboutus-link09"
            >
              <svg viewBox="0 0 602.2582857142856 1024" class="aboutus-icon2">
                <path
                  d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppNavbar from '../components/navbar'

export default {
  name: 'Aboutus',
  components: {
    AppNavbar,
  },

  data() {
    return {
      raw3np3: ' ',
      rawyljb: ' ',
    }
  },

  metaInfo: {
    title: 'About us - Madeira Roots',
    meta: [
      {
        name: 'description',
        content: 'Deep dive into Madeira Roots',
      },
      {
        property: 'og:title',
        content: 'About us - Madeira Roots',
      },
      {
        property: 'og:description',
        content: 'Deep dive into Madeira Roots',
      },
    ],
  },
}
</script>

<style scoped>
.aboutus-container {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.aboutus-top-container {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-size: cover;
  background-image: radial-gradient(circle at center, rgba(119, 109, 73, 0.2) 36.00%,rgba(70, 67, 56, 0.8) 100.00%),url('https://unsplash.com/photos/_6HzPU9Hyfg/download?ixid=MnwxMjA3fDB8MXxzZWFyY2h8MTh8fGVuZXJneSUyMHBvd2VyJTIwbmF0dXJlfGVufDB8fHx8MTY0OTUzNDEzOA&force=true');
  background-position: 0% 40%;
}
.aboutus-hero {
  flex: 1;
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1000px;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: center;
}
.aboutus-container1 {
  top: 80px;
  left: 32px;
  display: flex;
  position: absolute;
  align-self: flex-start;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.aboutus-text {
  color: #ffffff;
}
.aboutus-content-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.aboutus-container2 {
  flex: 0 0 auto;
  width: auto;
  border: 2px dashed rgba(120, 120, 120, 0.4);
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.aboutus-main {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-quadruple);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-quadruple);
  justify-content: center;
}
.aboutus-features {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  align-items: center;
  flex-direction: column;
}
.aboutus-text01 {
  font-size: 3rem;
  margin-bottom: 32px;
}
.aboutus-text03 {
  color: var(--dl-color-gray-700);
  width: 70%;
  font-size: 1.15rem;
  text-align: center;
}
.aboutus-footer {
  color: var(--dl-color-gray-white);
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-tripleunit);
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
.aboutus-menu {
  width: 100%;
  display: flex;
  max-width: 1000px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.aboutus-links-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.aboutus-container3 {
  display: flex;
  align-items: flex-start;
  margin-left: 100px;
  flex-direction: column;
}
.aboutus-link {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.aboutus-link01 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.aboutus-link02 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.aboutus-link03 {
  text-decoration: none;
}
.aboutus-container4 {
  display: flex;
  align-items: flex-start;
  margin-left: 100px;
  flex-direction: column;
}
.aboutus-link04 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.aboutus-link05 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.aboutus-link06 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.aboutus-link07 {
  text-decoration: none;
}
.aboutus-follow-container {
  display: flex;
  align-items: center;
  margin-left: 50px;
  flex-direction: column;
  justify-content: space-between;
}
.aboutus-text09 {
  padding-bottom: var(--dl-space-space-halfunit);
}
.aboutus-icons-container {
  width: 100px;
  display: flex;
  align-self: flex-end;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.aboutus-link08 {
  display: contents;
}
.aboutus-icon {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
.aboutus-link09 {
  display: contents;
}
.aboutus-icon2 {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
@media(max-width: 991px) {
  .aboutus-hero {
    padding-left: var(--dl-space-space-tripleunit);
    padding-right: var(--dl-space-space-tripleunit);
  }
  .aboutus-text01 {
    text-align: center;
  }
  .aboutus-text03 {
    text-align: center;
  }
}
@media(max-width: 767px) {
  .aboutus-hero {
    justify-content: center;
  }
  .aboutus-text {
    font-size: 2.5rem;
  }
  .aboutus-content-container {
    align-items: center;
  }
  .aboutus-main {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .aboutus-features {
    padding-left: 32px;
    padding-right: 32px;
  }
  .aboutus-text01 {
    text-align: center;
  }
  .aboutus-menu {
    flex-direction: column;
  }
  .aboutus-links-container {
    margin-top: var(--dl-space-space-tripleunit);
    margin-bottom: var(--dl-space-space-tripleunit);
    justify-content: space-between;
  }
  .aboutus-container3 {
    margin-left: 0px;
  }
}
@media(max-width: 479px) {
  .aboutus-text {
    font-size: 2rem;
    text-align: center;
  }
  .aboutus-features {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .aboutus-links-container {
    margin-top: var(--dl-space-space-doubleunit);
    align-items: flex-start;
    justify-content: flex-start;
  }
  .aboutus-link {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-link01 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-link02 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-link03 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-container4 {
    height: 100%;
    align-items: flex-start;
    margin-left: 50px;
  }
  .aboutus-link04 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-link05 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-link06 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-link07 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .aboutus-follow-container {
    margin-left: 0px;
  }
}
</style>
